import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters(["publicAuthEnabled"]),
    ...mapGetters("auth", ["user"]),
    showPublicUserFeatures() {
      return !!(this.user || this.publicAuthEnabled);
    },
  },
};
